import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Button, Typography, Table, Tag, Row, Col, Checkbox } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// Mock 物模型数据
const MOCK_MODEL_DATA = {
  standardCapabilities: [
    { id: 'cap_001', name: '视频流', category: '视频能力', properties: ['分辨率', '帧率', '比特率'], enabled: true },
    { id: 'cap_002', name: '双向语音', category: '语音能力', properties: ['采样率', '编码格式'], enabled: true },
    { id: 'cap_003', name: '夜视', category: '拍照能力', properties: ['夜视等级', '补光模式'], enabled: false },
    { id: 'cap_004', name: '移动检测', category: '智能识别', properties: ['检测灵敏度', '记录时长'], enabled: true },
    { id: 'cap_005', name: '人脸识别', category: '智能识别', properties: ['识别准确度', '库容量'], enabled: false },
  ],
  customCapabilities: [
    { id: 'custom_001', name: '云存储', category: '增值服务', properties: ['存储时长', '清晰度'], enabled: true },
    { id: 'custom_002', name: '告警推送', category: '通知服务', properties: ['推送频率', '推送渠道'], enabled: true },
  ]
};

const ModelView = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('productId') || '';
  const productName = decodeURIComponent(searchParams.get('productName') || '');
  const fwName = decodeURIComponent(searchParams.get('fwName') || '');
  const fwVersion = decodeURIComponent(searchParams.get('fwVersion') || '');
  const fwType = decodeURIComponent(searchParams.get('fwType') || '');
  const readonly = searchParams.get('readonly') === 'true';

  const standardColumns = [
    {
      title: '能力名称',
      dataIndex: 'name',
      width: 150,
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: '能力类别',
      dataIndex: 'category',
      width: 120,
      render: (text) => <Tag color="blue">{text}</Tag>,
    },
    {
      title: '属性配置',
      dataIndex: 'properties',
      render: (props) => (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {props.map((prop, idx) => (
            <Tag key={idx} color="cyan">{prop}</Tag>
          ))}
        </div>
      ),
    },
    {
      title: '启用',
      dataIndex: 'enabled',
      width: 80,
      render: (enabled) => (
        <Checkbox checked={enabled} disabled={readonly} />
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button icon={<ArrowLeftOutlined />} type="text" onClick={() => navigate(-1)} />
        <Title level={4} style={{ margin: 0 }}>物模型配置</Title>
      </div>

      <Card bordered={false} size="small" style={{ marginBottom: 20, background: '#fafafa', borderRadius: 8 }} bodyStyle={{ padding: '12px 16px' }}>
        <Row gutter={[24, 12]}>
          <Col span={12}>
            <div><Text type="secondary">产品名称</Text></div>
            <div style={{ fontWeight: 500, marginTop: 4 }}>{productName}</div>
          </Col>
          <Col span={12}>
            <div><Text type="secondary">产品ID</Text></div>
            <div style={{ fontWeight: 500, marginTop: 4, fontFamily: 'monospace' }}>{productId}</div>
          </Col>
          <Col span={12}>
            <div><Text type="secondary">固件名称</Text></div>
            <div style={{ fontWeight: 500, marginTop: 4 }}>{fwName}</div>
          </Col>
          <Col span={12}>
            <div><Text type="secondary">固件版本</Text></div>
            <div style={{ fontWeight: 500, marginTop: 4 }}>{fwVersion}</div>
          </Col>
          <Col span={12}>
            <div><Text type="secondary">固件类型</Text></div>
            <div style={{ fontWeight: 500, marginTop: 4 }}><Tag color={fwType === '生产固件' ? 'blue' : 'orange'}>{fwType}</Tag></div>
          </Col>

        </Row>
      </Card>

      <Card bordered={false} style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 16 }}>
          <Title level={5} style={{ margin: 0 }}>标准能力库</Title>
          <Text type="secondary" style={{ fontSize: 12 }}>该固件实现的标准IOT能力</Text>
        </div>
        <Table
          columns={standardColumns}
          dataSource={MOCK_MODEL_DATA.standardCapabilities}
          rowKey="id"
          size="small"
          pagination={false}
          bordered
        />
      </Card>

      <Card bordered={false} style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 16 }}>
          <Title level={5} style={{ margin: 0 }}>自定义能力</Title>
          <Text type="secondary" style={{ fontSize: 12 }}>该固件支持的增值或定制化能力</Text>
        </div>
        <Table
          columns={standardColumns}
          dataSource={MOCK_MODEL_DATA.customCapabilities}
          rowKey="id"
          size="small"
          pagination={false}
          bordered
        />
      </Card>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
        <Button onClick={() => navigate(-1)}>返回</Button>
      </div>
    </div>
  );
};

export default ModelView;
